import Vue from 'vue';
import vbclass from 'vue-body-class';
import Router from 'vue-router';

import Layout from '@/components/layout/Layout';
import McMap from '@/components/McMap';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '/:defaultTraficLayer?',
          name: 'McMap',
          component: McMap,
          props: route => ({ defaultTraficLayer: route.params.defaultTraficLayer }),
          params: { defaultTraficLayer: false },
          meta: {
            bodyClass: 'has-navbar-fixed-top'
          }
        }
      ]
    }
  ]
});

Vue.use(vbclass, router);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js